import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DefaultIcon from './crypto-logo.svg';
import styled from 'styled-components';

const FreeTextInput = styled.input`
  border: 3px solid #eee;
`;

export default function FreeTextSearch(props) {
  return <FreeTextInput onChange={props.onUpdate} />;
}

FreeTextSearch.propTypes = {
  onUpdate: PropTypes.func,
};
